import { i18n as Ti18n } from 'i18next'
import { ILocation } from 'containers/dashboard/features/employees/store/types'

interface IClassName {
    i18n: Ti18n
    uk: string
    eng: string
}

export const getLocationsBody = (value: ILocation | undefined) => {
    if (value) {
        return {
            name: value.name,
            address: value.address,
            description: value.description,
            photoUrl: value.imageUrl,
        }
    }

    return { name: '', address: '', description: '', photoUrl: '' }
}

export const getClassNameForLanguage = ({ i18n, uk, eng }: IClassName) => {
    return i18n.language === 'uk' ? uk : eng
}
